import React from 'react'
import { CCol, CRow, CInput, CButton, CTooltip } from '@coreui/react';
import Pagination from "react-js-pagination";
import Loader from "react-loader-spinner";
import DateFormat from "../ui-components/DateFormat";

const defaultScopeAction = (element, value) => {
    return (value) ?
        <td>true</td>
        :
        <td>false</td>
}

const defaultScope = [
    {
        column: 'isActive',
        renderTableData: defaultScopeAction.bind(this)
    }
]

//Dynamic row binding into the table
export function Rows(props) {
    return (
        props && props.columns && props.columns.map((element, index) => {            
            return (
                (props.customScope && props.customScope.filter(c => c.column.toLowerCase() === element.name.toLowerCase()).length > 0) ?
                    props.customScope.filter(c => c.column.toLowerCase() === element.name.toLowerCase())[0].renderTableData(element.name, props.index, props.tableData[Object.keys(props.tableData).find(objKey => objKey.toLowerCase() === element.name.toLowerCase())])
                    :
                    (props.defaultScope && props.defaultScope.filter(c => c.column.toLowerCase() === element.name.toLowerCase()).length > 0) ?
                        props.defaultScope.filter(c => c.column.toLowerCase() === element.name.toLowerCase())[0].renderTableData(element.name, props.tableData[Object.keys(props.tableData).find(objKey => objKey.toLowerCase() === element.name.toLowerCase())])
                        :
                        <td className={(props.isCollapsedSection)?"pointer":''} onClick={()=>(props.isCollapsedSection)?props.setCollapse(props.index,props.isCollapsed):null}>
                            {props.tableData[Object.keys(props.tableData).find(objKey => objKey.toLowerCase() === element.name.toLowerCase())]}
                        </td>
            )
        })
    )
}

const Table = (props) => {
    // Sorting handler
    const handleSorting = (columnName, value) => {
        props.pagination.pageNo = 1;
        props.pagination.orderByColumn = columnName;
        props.pagination.orderFlag = (value) ? 1 : 0;
        props.getList(props.pagination);
    }

    //Search box handler
    const handleSearch = (value) => {
        props.pagination.searchText = value.trim();
        if (value && value.length > 2) {
            props.getList(props.pagination);
            props.getSearchValue(props.value);
            
        }
        else if (value.trim() === "") {
            props.getList(props.pagination);
        }
    }
     
    //Pagination handler
    const handlePageChange = (pageNumber) => {
        if (props.pagination.pageNo !== pageNumber) {
            props.pagination.pageNo = pageNumber;
            props.getList(props.pagination);
        }
    };

    return (
        (props.isLoading) ?
            <Loader
                className="row"
                style={{ marginTop: '50px', marginBottom: '50px', }}
                type="Bars"
                color="#3c4b64"
                height={50}
                width={50}
            />
            :
            <>
            {/* Table Section */}
            <div className='row'>
                <form className="col-auto search_field mb-3">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1"><i className="fal fa-search"></i></span>
                        </div>
                        <CInput
                            type="text"
                            id="text-input"
                            name="text-input"
                            placeholder="Name"
                            onChange={(e) => handleSearch(e.target.value)}
            
                        />
                        
                      {(props.refreshButton) ? props.refreshButton() : null}                  
                                                                
                    </div>
                    
                </form>
                
                {(props.advancedFilter) ? props.advancedFilter():null}
                
                {(props.isAdd !== false) ? 
                <div className=" col">
                    <CButton
                        className="btn float-right"
                        shape=""
                        style={{background: "#1b2330" , color:" #fff "}}
                        onClick={()=>props.redirectToAdd()}
                      >
                        <i className="fal fa-plus pr-3"></i>
                        Add
                    </CButton>
                    </div>
                    : null}
            </div>
            <div className="table-responsive">
                <table className="table table-hover ">
                    <thead>
                        <tr>
                            {(props && props.columns.map((value, key) => {
                                return (
                                    <th>
                                        {value.title}
                                        {(props.sortingColumns.includes(value.name)) ? (props.pagination.orderFlag === 1 && props.pagination.orderByColumn.toLowerCase() === value.name.toLowerCase()) ?
                                            <i className="fas fa-angle-double-down pl-3" onClick={() => handleSorting(value.name, !props.pagination.orderFlag)}></i>
                                            :
                                            <i className="fas fa-angle-double-up pl-3" onClick={() => handleSorting(value.name, !props.pagination.orderFlag)}></i>
                                            :
                                            null}
                                    </th>
                                )
                            }))}
                        </tr>
                    </thead>
                    <tbody>
                       
                        {(props && props.rows && props.rows.length > 0) ?
                            props.rows.map((value, key) => {                                
                                if(value.createdAt){
                                    value.createdAt = <DateFormat date={value.createdAt}/> 
                                }                              
                                return (
                                    <>                                  
                                    {/* {(value.externalReference !== undefined && value.externalReference !== null) ? 
                                      <CTooltip content={value.externalReference} placement="top">
                                     <tr className="color-orange"><Rows columns={props.columns} tableData={value} customScope={props.customScope} defaultScope={defaultScope} index={key} setCollapse={props.setCollapse} isCollapsedSection={props.isCollapsedSection}
                                     isCollapsed={value.isCollapsed}/></tr>
                                       </CTooltip>
                                    :
                                    <tr><Rows columns={props.columns} tableData={value} customScope={props.customScope} defaultScope={defaultScope} index={key} setCollapse={props.setCollapse} isCollapsedSection={props.isCollapsedSection}
                                    isCollapsed={value.isCollapsed}/></tr>
                                    } */}
                                    <tr><Rows columns={props.columns} tableData={value} customScope={props.customScope} defaultScope={defaultScope} index={key} setCollapse={props.setCollapse} isCollapsedSection={props.isCollapsedSection}
                                    isCollapsed={value.isCollapsed}/></tr>
                                    {(value.isCollapsed)? 
                                        props.collapsibleSection(value)
                                    :null
                                    }
                                    </>
                                )
                               
                            })
                            :
                            <tr><td colspan={props.columns.length} className="text-center p-4"><i className="fas fa-empty-set pr-2"></i>No Records Found</td></tr>
                        }
                    </tbody>
                </table>
            </div>

            {/* Pagination Section */}
            <CRow>
                <CCol className="my-auto">
                    <p>Showing <span>{(props.pagination)? ((props.pagination.pageSize * props.pagination.pageNo) - (props.pagination.pageSize-1)) : 0} - {(props.pagination) ? ((props.pagination.pageSize * props.pagination.pageNo) >= props.totalCount)? props.totalCount : props.pagination.pageSize * props.pagination.pageNo : 0}</span> of <span>{(props.totalCount !== undefined) ? props.totalCount : 0}</span> records</p>
                </CCol>
                <CCol className="ml-auto">
                    <Pagination
                        hideDisabled
                        activePage={props.pagination.pageNo}
                        itemsCountPerPage={props.pagination.pageSize}
                        totalItemsCount={props.totalCount}
                        pageRangeDisplayed={3}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                    />
                </CCol>
            </CRow>
            </>
    )
}

export default Table;
